import React from 'react';
import PropTypes from 'prop-types';

import FluidImage from '../../../common/image/fluid';
import './styles.sass';

const ImageWidgets = ({ widgets }) => {
  return widgets ? (
    <>
      {widgets.map(({ altTag, url, image }) => {
        return (
          <section
            className="block block__image-widget"
            key={image.sourceUrl + url}
          >
            <a className="image-widget__link" href={url}>
              <FluidImage image={image} alt={altTag} />
            </a>
          </section>
        );
      })}
    </>
  ) : null;
};

ImageWidgets.propTypes = {
  widgets: PropTypes.arrayOf(
    PropTypes.shape({
      altTag: PropTypes.string,
      url: PropTypes.string,
      // eslint-disable-next-line react/forbid-prop-types
      image: PropTypes.object,
    })
  ),
};

ImageWidgets.defaultProps = {
  widgets: null,
};

export default ImageWidgets;
